
export class ReqPermissionList {
    constructor({ companyId, roleId, start, limit }) {
        this.companyId = companyId
        this.roleId = roleId
        this.start = start
        this.limit = limit
    }

    fromJson(jsonData) {
        this.companyId = jsonData.companyId
        this.roleId = jsonData.roleId
        this.start = jsonData.start
        this.limit = jsonData.limit
    }
}

export class RespPermissionList {
    fromJson(jsonData) {
        this.list = []
        if (jsonData !== undefined && jsonData.length > 0) {
            jsonData.map(item => {
                var mReqPermission = new ReqPermission({})
                mReqPermission.fromJson(item)
                this.list.push(mReqPermission)
            })
        }
    }
}

export class ReqPermission {
    constructor({ pageId, roleId, isView, isAdd = 0, isEdit = 0, isDelete = 0 }) {
        this.pageId = pageId
        this.roleId = roleId
        this.isView = isView
        this.isAdd = isAdd
        this.isEdit = isEdit
        this.isDelete = isDelete
    }

    fromJson(jsonDate) {
        this.pageId = jsonDate.pageId
        this.roleId = jsonDate.roleId
        this.isView = jsonDate.isView
        if (jsonDate.isAdd !== undefined)
            this.isAdd = jsonDate.isAdd
        if (jsonDate.isEdit !== undefined)
            this.isEdit = jsonDate.isEdit
        if (jsonDate.isDelete !== undefined)
            this.isDelete = jsonDate.isDelete
    }

    toString() {
        return 'Name: ' + this.fullName + ', Age:' + this.age
    }
}
